/*
 * @Author: JamesWong
 * @Description: 账户配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 14:59:12
 */
export default {
  basicInformation: 'Basic Information',
  enterpriseNumber: 'Enterprise Number',
  enterpriseName: 'Enterprise Name'
}


// WEBPACK FOOTER //
// ./src/i18n/en/account.js